import React from 'react'
import { A, Icon, Text } from '@rebrandly/styleguide'

import './Proof.css'

const Proof = () => {
  return (
    <div className='Proof'>
      <div className='Proof__container container'>
        <div className='Proof__opinions-container'>
          <Text size='3x-large' className='Proof__title m-b-36'>Don’t just take our word for it</Text>
          <A
            target='_blank'
            href='https://www.trustpilot.com/review/www.rebrandly.com'
            rel='noopener noreferrer'
          >
            <div className='flex Proof__opinion'>
              <span>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
              </span>
              <Text size='x-large' className='p-l-36'>5/5</Text>
              <Text size='medium' className='p-l-8'>TrustPilot</Text>
            </div>
          </A>
          <A
            target='_blank'
            href='https://www.capterra.com/p/166180/Rebrandly/'
            rel='noopener noreferrer'
          >
            <div className='flex Proof__opinion'>
              <span>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
              </span>
              <Text size='x-large' className='p-l-36'>5/5</Text>
              <Text size='medium' className='p-l-8'>Capterra</Text>
            </div>
          </A>
          <A
            target='_blank'
            href='https://www.g2.com/products/rebrandly/reviews'
            rel='noopener noreferrer'
          >
            <div className='flex Proof__opinion'>
              <span>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star.svg' alt='star'/>
                <img src='./images/star-half.svg' alt='star'/>
              </span>
              <Text size='x-large' className='p-l-36'>4.6/5</Text>
              <Text size='medium' className='p-l-8'>G2Crowd</Text>
            </div>
          </A>
        </div>
        <div className='Proof__stats-container'>
          <div className='Proof__stat'>
          <div>
              <Icon
                background
                name='ic-api'
                size='regular'
                className='Proof__icon'
              />
            </div>
            <Text size='x-large'>90,000</Text>
            <Text size='regular'>Developers using our APIs</Text>
          </div>
          <div className='Proof__stat'>
            <div>
            <Icon
                background
                name='ic-click'
                size='regular'
                className='Proof__icon'
              />
            </div>
            <Text size='x-large'>2 Billon</Text>
            <Text size='regular'>Clicks tracked each month</Text>
          </div>
          <div className='Proof__stat'>
            <div>
            <Icon
                background
                name='ic-emoticon'
                size='regular'
                className='Proof__icon'
              />
            </div>
            <Text size='x-large'>1.3 Millon</Text>
            <Text size='regular'>Happy customers</Text>
          </div>
          <div className='Proof__stat'>
            <div>
            <Icon
                background
                name='ic-domain-www'
                size='regular'
                className='Proof__icon'
              />
            </div>
            <Text size='x-large'>1 Billon</Text>
            <Text size='regular'>Branded links created</Text>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Proof
